/* LLAMA Truck Help Center — shared behaviour (assets/llama-help-center.js)
   Event-delegated, so the hero search, category cards and FAQ list work
   across separate sections, in any order, and survive theme-editor reloads. */
(function () {
  if (window.__lhcReady) return;
  window.__lhcReady = true;

  var state = { category: 'all', term: '' };

  function all(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function update() {
    var visible = 0;
    var counts = {};

    all('.lhc .faq-item').forEach(function (item) {
      var cat = item.dataset.category;
      counts[cat] = (counts[cat] || 0) + 1;
      var categoryMatch = state.category === 'all' || cat === state.category;
      var text = (item.textContent + ' ' + (item.dataset.search || '')).toLowerCase();
      var show = categoryMatch && (!state.term || text.indexOf(state.term) !== -1);
      item.hidden = !show;
      if (show) visible++;
    });

    all('.lhc [data-lhc-results]').forEach(function (el) {
      el.textContent = visible + ' ' + (visible === 1 ? el.dataset.one : el.dataset.many);
    });

    all('.lhc [data-lhc-title]').forEach(function (el) {
      var title = el.dataset.default;
      all('.lhc .topic-tab').forEach(function (tab) {
        if (tab.dataset.lhcFilter === state.category && tab.dataset.title) title = tab.dataset.title;
      });
      el.textContent = state.term ? el.dataset.search : title;
    });

    all('.lhc [data-lhc-empty]').forEach(function (el) {
      el.classList.toggle('show', visible === 0);
    });

    all('.lhc [data-lhc-filter]').forEach(function (el) {
      el.classList.toggle('active', el.dataset.lhcFilter === state.category);
    });

    all('.lhc [data-lhc-count]').forEach(function (el) {
      el.textContent = pad(counts[el.dataset.lhcCount] || 0) + ' ' + (el.dataset.suffix || '');
    });
  }

  function scrollToFaq() {
    var target = document.querySelector('[data-lhc-faq]');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var filter = e.target.closest('[data-lhc-filter]');
    if (filter) {
      state.category = filter.dataset.lhcFilter;
      update();
      scrollToFaq();
      return;
    }
    if (e.target.closest('[data-lhc-search-btn]')) {
      update();
      scrollToFaq();
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-lhc-search]')) return;
    state.term = e.target.value.trim().toLowerCase();
    all('[data-lhc-search]').forEach(function (input) {
      if (input !== e.target) input.value = e.target.value;
    });
    update();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-lhc-search]')) {
      e.preventDefault();
      update();
      scrollToFaq();
    }
  });

  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();